var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#FAFAFA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90009 10.2649C3.70315 10.2653 3.50808 10.2267 3.32609 10.1515C3.1441 10.0762 2.97876 9.96573 2.83959 9.8264L0.0430908 7.0304L0.750091 6.32289L3.54659 9.1194C3.64035 9.21313 3.76751 9.26579 3.90009 9.26579C4.03267 9.26579 4.15983 9.21313 4.25359 9.1194L11.2501 2.12289L11.9571 2.82989L4.96059 9.8264C4.82142 9.96573 4.65608 10.0762 4.47409 10.1515C4.2921 10.2267 4.09703 10.2653 3.90009 10.2649Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.789c424d13c57d73e2cdea72c3089f1e.svg";
export { ForwardRef as ReactComponent };